
import type { SVGProps } from 'react';
const SvgKaffeemaschine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#kaffeemaschine_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M10.486 5h3.73a3.49 3.49 0 0 1 3.486 3.486v8.185a.25.25 0 0 1-.5 0V9.525h-2.936v8.745h2.937v-.498a.25.25 0 0 1 .5 0v.951c0 .704-.573 1.277-1.278 1.277H8.277A1.28 1.28 0 0 1 7 18.723v-.203a.25.25 0 0 1 .25-.25h1.118a1.54 1.54 0 0 1-.413-1.05v-1.33a.25.25 0 0 1 .5 0v1.33c0 .58.47 1.05 1.05 1.05h2.008a1.05 1.05 0 0 0 1.049-1.049v-1.993H9.257a.25.25 0 0 1 0-.5h3.555a.25.25 0 0 1 .25.25v2.243c0 .405-.158.773-.413 1.05h1.117V9.524h-.313c-.039.753-.649 1.253-1.545 1.253h-.666a.25.25 0 0 1 0-.5h.666c.238 0 .995-.055 1.046-.753H8.063c.05.698.809.753 1.046.753h.675a.25.25 0 0 1 0 .5H9.11c-.896 0-1.507-.5-1.545-1.253H7.25a.25.25 0 0 1-.25-.25v-.79c0-.536.119-1.051.354-1.53a.25.25 0 0 1 .448.22c-.2.41-.302.85-.302 1.31v.54h9.703v-.54A2.99 2.99 0 0 0 14.217 5.5h-3.732q-.335 0-.659.073a.25.25 0 0 1-.11-.488 3.5 3.5 0 0 1 .77-.085m5.94 14.5a.78.78 0 0 0 .775-.73H7.502c.024.407.362.73.775.73zm-.459-7.658v-1.046a.25.25 0 0 0-.5 0v1.046a.25.25 0 0 0 .5 0m-1.036 1.604a.802.802 0 0 0 1.603 0 .802.802 0 0 0-1.603 0m.802-.301a.302.302 0 1 1-.001.603.302.302 0 0 1 0-.603"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="kaffeemaschine_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKaffeemaschine;
